import { AMLS_TM_SAM } from '../../pages/constants/globalConstants';
import { createAxiosServiceInstance } from '../api';

const axios = createAxiosServiceInstance();

export async function getMetadata(payload) {
  const url = `${AMLS_TM_SAM}/masterData`;

  return await axios.get(url);
}
